import { render, staticRenderFns } from "./common-rectangle.vue?vue&type=template&id=7c81ce7f&scoped=true"
import script from "./common-rectangle.vue?vue&type=script&lang=js"
export * from "./common-rectangle.vue?vue&type=script&lang=js"
import style0 from "./common-rectangle.vue?vue&type=style&index=0&id=7c81ce7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c81ce7f",
  null
  
)

export default component.exports